/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/
import 'styles/style.scss';
/*------------------------------------------------------------------
Add scripts to the Script Loader object below
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './components/in-view': true,
    './components/lazy-load': true,
    './components/selectors': document.querySelector('select'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/breakpoint': document.querySelector('[data-breakpoint]'),
    './elements/search': true,
    './elements/header': true,
    './components/scroll': true,
    './components/scroll-to': true,
    './elements/mobile-menu': true,
    './elements/contact-modal': document.querySelector('.js-questions'),
    './elements/contact-form': document.querySelector('#ContactForm_ContactForm'),
    './elements/accordion': document.querySelector('.js-accordion'),
    './blocks/video': document.querySelector('[data-video]'),
    './blocks/tabs': document.querySelector('.js-tabs'),
    './blocks/team': document.querySelector('.js-team-block'),
    './pages/fund-holder': document.querySelector('.js-fund-risk-scale'),
    './pages/search-results': document.querySelector('.js-search-results'),
    './pages/blog': document.querySelector('.js-blog'),
    './components/equalizer': document.querySelector('[data-equalize-watch]')
  });
});
/*------------------------------------------------------------------
ScriptLoader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // An array of the import object keys
  var scripts = Object.keys(imports); // For debugging purposes only

  var components = [];

  var load = function load() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

    // Make sure we have a script to import
    if (i >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event 
      setTimeout(function () {
        return window.dispatchEvent(new Event('scripts-loaded'));
      }, 500);
      return;
    }

    ; // Increment the index

    i += 1; // If this script is not needed, continue to the next script;

    if (!imports[scripts[i]]) {
      load(i);
      return;
    }

    ; // Otherwise continue on to load the script

    import("".concat(scripts[i])).then(function () {
      return components.push(scripts[i]);
    })["catch"](function (error) {
      return console.warn(error);
    })["finally"](function () {
      return load(i);
    });
  };

  load();
  return components;
}

window.addEventListener('scripts-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
});